<template>
  <Navbar />
  <router-view />
</template>
<script>
import Navbar from "./components/Navbar";
export default {
  components: {
    Navbar,
  },
  name: "App",
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
